import { BaSeSideMenu } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { Role } from '../../models/role';
import { SideMenu } from './footer-styled';

export const LayoutAside = () => {
  const { isAuthenticated, hasRoles } = Sebrae.useAuth();
  const { navigateTo, isInRoute } = Sebrae.useRouter();

  const linkSideBar = [
    {
      label: 'Relatórios',
      active: isInRoute('/relatorio/cliente'),
      subItens: [
        {
          label: 'Clientes - Fluxo Relacionamento',
          active: isInRoute('/relatorio/cliente'),
          callback() {
            navigateTo('/relatorio/cliente');
          },
        },
        {
          label: 'Clientes - Cadastro Completo',
          active: isInRoute('/relatorio/cliente-cadastro-completo'),
          callback() {
            navigateTo('/relatorio/cliente-cadastro-completo');
          },
        },
        {
          label: 'Operações de Crédito',
          active: isInRoute('/relatorio/operacao-credito'),
          callback() {
            navigateTo('/relatorio/operacao-credito');
          },
        },
        {
          label: 'Monitoramento Pré e Pós Crédito - Sintético',
          active: isInRoute('/relatorio/manutencao-relacionamento-sintetico'),
          callback() {
            navigateTo('/relatorio/manutencao-relacionamento-sintetico');
          },
        },
        {
          label: 'Monitoramento Pré e Pós Crédito - Analítico',
          active: isInRoute('/relatorio/manutencao-relacionamento-analitico'),
          callback() {
            navigateTo('/relatorio/manutencao-relacionamento-analitico');
          },
        },
        {
          label: 'Monitoramento de Rotinas Automáticas',
          active: isInRoute('/relatorio/automatic-routines-monitoring'),
          callback() {
            navigateTo('/relatorio/automatic-routines-monitoring');
          },
        },
        {
          label: 'Orientação para Crédito - consulta IFs',
          active: isInRoute('/relatorio/exigibilidade-mpo'),
          callback() {
            navigateTo('/relatorio/exigibilidade-mpo');
          },
        },
        {
          label: 'Portfolios Parametrizadas',
          active: isInRoute('/relatorio/relatorio-solucoes-parametrizadas'),
          callback() {
            navigateTo('/relatorio/relatorio-solucoes-parametrizadas');
          },
        },
      ],
    },
  ];

  const configSideBarItens = [
    {
      label: 'Configuração',
      active: isInRoute('/relatorio/cliente'),
      subItens: [
        {
          label: 'Configurar perfil de acesso',
          active: isInRoute('/configurar-perfil-acesso'),
          callback() {
            navigateTo('/configurar-perfil-acesso');
          },
        },
        {
          label: 'Parâmetros de atendimento',
          active: isInRoute('/informar-projeto-acao'),
          callback() {
            navigateTo('/informar-projeto-acao');
          },
        },
        // {
        //   label: 'Parametrizar UF para e-mailo',
        //   active: isInRoute('/parametrizar-uf-email'),
        //   callback() {
        //     navigateTo('/parametrizar-uf-email');
        //   },
        // },
        {
          label: 'Parametrizar Portfolios',
          active: isInRoute('/parametrizar-solucoes'),
          callback() {
            navigateTo('/parametrizar-solucoes');
          },
        },
        {
          label: 'Agrupar Portfolios',
          active: isInRoute('/agrupar-solucoes'),
          callback() {
            navigateTo('/agrupar-solucoes');
          },
        },
        {
          label: 'Vincular cliente a uma IF',
          active: isInRoute('/vincular-cliente-if'),
          callback() {
            navigateTo('/vincular-cliente-if');
          },
        },
      ],
    },
  ];

  const importFileSideBarItens = [
    {
      label: 'Importação de Arquivo',
      active: isInRoute('/importar-clientes-bndes'),
      subItens: [
        {
          label: 'Importar Cliente FGBS',
          active: isInRoute('/importar-clientes-bndes'),
          callback() {
            navigateTo('/importar-clientes-bndes');
          },
        },
      ],
    },
  ];

  return (
    <SideMenu>
      {isAuthenticated && hasRoles([Role.Administrador]) && (
        <>
          <BaSeSideMenu itens={linkSideBar} themeMode="light" />
          <BaSeSideMenu itens={configSideBarItens} themeMode="light" />
          <BaSeSideMenu itens={importFileSideBarItens} themeMode="light" />
        </>
      )}
      {isAuthenticated && hasRoles([Role.GestorNacional]) && (
        <BaSeSideMenu
          itens={[
            {
              label: 'Relatórios',
              active: isInRoute('/relatorio/cliente'),
              subItens: [
                {
                  label: 'Clientes - Fluxo Relacionamento',
                  active: isInRoute('/relatorio/cliente'),
                  callback() {
                    navigateTo('/relatorio/cliente');
                  },
                },
                {
                  label: 'Clientes - Cadastro Completo',
                  active: isInRoute('/relatorio/cliente-cadastro-completo'),
                  callback() {
                    navigateTo('/relatorio/cliente-cadastro-completo');
                  },
                },
                {
                  label: 'Operações de Crédito',
                  active: isInRoute('/relatorio/operacao-credito'),
                  callback() {
                    navigateTo('/relatorio/operacao-credito');
                  },
                },
                {
                  label: 'Monitoramento Pré e Pós Crédito - Sintético',
                  active: isInRoute(
                    '/relatorio/manutencao-relacionamento-sintetico',
                  ),
                  callback() {
                    navigateTo(
                      '/relatorio/manutencao-relacionamento-sintetico',
                    );
                  },
                },
                {
                  label: 'Monitoramento Pré e Pós Crédito - Analítico',
                  active: isInRoute(
                    '/relatorio/manutencao-relacionamento-analitico',
                  ),
                  callback() {
                    navigateTo(
                      '/relatorio/manutencao-relacionamento-analitico',
                    );
                  },
                },
                {
                  label: 'Orientação para Crédito - consulta IFs',
                  active: isInRoute('/relatorio/exigibilidade-mpo'),
                  callback() {
                    navigateTo('/relatorio/exigibilidade-mpo');
                  },
                },
                {
                  label: 'Portfolios Parametrizadas',
                  active: isInRoute(
                    '/relatorio/relatorio-solucoes-parametrizadas',
                  ),
                  callback() {
                    navigateTo('/relatorio/relatorio-solucoes-parametrizadas');
                  },
                },
              ],
            },
            {
              label: 'Configuração',
              active: isInRoute('/parametrizar-solucoes'),
              subItens: [
                {
                  label: 'Parametrizar Portfolios',
                  active: isInRoute('/parametrizar-solucoes'),
                  callback() {
                    navigateTo('/parametrizar-solucoes');
                  },
                },
              ],
            },
          ]}
          themeMode="light"
        />
      )}
      {isAuthenticated && hasRoles([Role.GestorUF]) && (
        <BaSeSideMenu
          itens={[
            {
              label: 'Relatórios',
              active: isInRoute('/relatorio/cliente'),
              subItens: [
                {
                  label: 'Clientes - Fluxo Relacionamento',
                  active: isInRoute('/relatorio/cliente'),
                  callback() {
                    navigateTo('/relatorio/cliente');
                  },
                },
                {
                  label: 'Clientes - Cadastro Completo',
                  active: isInRoute('/relatorio/cliente-cadastro-completo'),
                  callback() {
                    navigateTo('/relatorio/cliente-cadastro-completo');
                  },
                },
                {
                  label: 'Operações de Crédito',
                  active: isInRoute('/relatorio/operacao-credito'),
                  callback() {
                    navigateTo('/relatorio/operacao-credito');
                  },
                },
              ],
            },
            {
              label: 'Configuração',
              active: isInRoute('/parametrizar-solucoes'),
              subItens: [
                {
                  label: 'Parametrizar Portfolios',
                  active: isInRoute('/parametrizar-solucoes'),
                  callback() {
                    navigateTo('/parametrizar-solucoes');
                  },
                },
              ],
            },
          ]}
          themeMode="light"
        />
      )}
      {isAuthenticated && hasRoles([Role.GestorIF]) && (
        <BaSeSideMenu
          itens={[
            {
              label: 'Relatórios',
              active: isInRoute('/relatorio/cliente'),
              subItens: [
                {
                  label: 'Clientes - Fluxo Relacionamento',
                  active: isInRoute('/relatorio/cliente'),
                  callback() {
                    navigateTo('/relatorio/cliente');
                  },
                },
                {
                  label: 'Clientes - Cadastro Completo',
                  active: isInRoute('/relatorio/cliente-cadastro-completo'),
                  callback() {
                    navigateTo('/relatorio/cliente-cadastro-completo');
                  },
                },
                {
                  label: 'Operações de Crédito',
                  active: isInRoute('/relatorio/operacao-credito'),
                  callback() {
                    navigateTo('/relatorio/operacao-credito');
                  },
                },
                {
                  label: 'Monitoramento Pré e Pós Crédito - Sintético',
                  active: isInRoute(
                    '/relatorio/manutencao-relacionamento-sintetico',
                  ),
                  callback() {
                    navigateTo(
                      '/relatorio/manutencao-relacionamento-sintetico',
                    );
                  },
                },
                {
                  label: 'Monitoramento Pré e Pós Crédito - Analítico',
                  active: isInRoute(
                    '/relatorio/manutencao-relacionamento-analitico',
                  ),
                  callback() {
                    navigateTo(
                      '/relatorio/manutencao-relacionamento-analitico',
                    );
                  },
                },
                {
                  label: 'Orientação para Crédito - consulta IFs',
                  active: isInRoute('/relatorio/exigibilidade-mpo'),
                  callback() {
                    navigateTo('/relatorio/exigibilidade-mpo');
                  },
                },
              ],
            },
          ]}
          themeMode="light"
        />
      )}
    </SideMenu>
  );
};
